import React from 'react';

import {
  Box,
  usePagination,
  IconDoubleChevronLeft,
  IconDoubleChevronRight,
  ResponsivePagination,
} from '@tq/ui-components';
import { useThemedValueSwitch } from '@tq/ui-components/dist/hooks';

import { StatisticsChart } from '..';
import { StatisticsReport } from 'types';

export const StatisticsChartDisplay: React.FC<{
  width?: string;
  statisticsResponse: StatisticsReport;
}> = ({ width, statisticsResponse }) => {
  const { isTQ } = useThemedValueSwitch();
  const reportKeys = Object.keys(statisticsResponse.reportData);
  const itemsPerPage = 6;
  const { currentItems, jump, prev, next, currentPage, maxPage } = usePagination({
    items: Object.entries(reportKeys),
    itemsPerPage,
  });
  const customPaginationPrev = {
    iconPrev: <IconDoubleChevronLeft />,
    justifyContent: 'flex-end',
  };

  const customPaginationNext = {
    iconNext: <IconDoubleChevronRight />,
    justifyContent: 'flex-start',
  };

  const tqPaginationStyles = {
    '& .tqc-stack > div': {
      justifyContent: 'center',
    },

    '& .tqc-pagination-previous': {
      flex: 0,

      '& button': {
        justifyContent: 'center',
      },

      '& + div': {
        flex: 0,
        mx: '1.5rem',
      },
    },

    '& .tqc-pagination-next': {
      flex: 0,

      '& button': {
        justifyContent: 'center',
      },
    },
  };

  return (
    <>
      {currentItems.map(([key, title]) => (
        <Box key={key} w={width}>
          <StatisticsChart statistics={statisticsResponse.reportData[title]} title={title} />
        </Box>
      ))}
      {!isTQ && (
        <ResponsivePagination
          className='responsive-pagination-container'
          pageNumber={currentPage}
          pageCount={maxPage}
          pageSize={itemsPerPage}
          paginationWithDots={false}
          customPaginationNavigatePrevious={customPaginationPrev}
          customPaginationNavigateNext={customPaginationNext}
          paginationInfo={{
            onNumberClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              jump(Number(e.currentTarget.value));
            },

            onPrevClick: () => {
              prev();
            },

            onNextClick: () => {
              next();
            },

            sx: isTQ ? tqPaginationStyles : {},
          }}
        />
      )}
    </>
  );
};
